
define('text!presentation/common/smsAttachmentLoadingOverlay/views/smsAttachmentLoadingOverlay.html',[],function () { return '<div class="sms-attachment-loading-overlay">\n    <div class="sms-attachment-loading-overlay__loading-bar"\n         data-bind="loadingBar: {\n                        progressValue: loadingBarProgressValue\n                    }">\n    </div>\n</div>\n';});

